import {v4 as uuid_v4} from "uuid";

export function extractFaces(imageRect, skeletons, optionsArg) {
  const options = Object.assign({
    paddingX: 0,
    paddingY: 0,
    checkIntersections: false,
  }, optionsArg);

  const faces = skeletons.map((skeleton) => {
    const leftEar = skeleton.skeletonPoints.find((point) => point.groupName === "left_ear" && point.p > 0);
    const rightEar = skeleton.skeletonPoints.find((point) => point.groupName === "right_ear" && point.p > 0);
    const neck = skeleton.skeletonPoints.find((point) => point.groupName === "neck" && point.p > 0);
    const nose = skeleton.skeletonPoints.find((point) => point.groupName === "nose" && point.p > 0);

    if (!nose) {
      return null;
    }

    let size = 0;
    if (leftEar && rightEar) {
      size = Math.max(distance(nose, leftEar), distance(nose, rightEar));
    } else if (leftEar) {
      size = distance(nose, leftEar);
    } else if (rightEar) {
      size = distance(nose, rightEar);
    } else if (neck) {
      size = distance(nose, neck) * 0.8;
    } else {
      return null;
    }

    const realRect = {
      x1: leftEar ? leftEar.x : (nose.x - size),
      y1: nose.y - size * 1.5,
      x2: rightEar ? rightEar.x : (nose.x + size),
      y2: nose.y + size,
    };

    const xpad = (realRect.x2 - realRect.x1) * options.paddingX;
    const ypad = (realRect.y2 - realRect.y1) * options.paddingY;

    realRect.x1 = Math.max(realRect.x1, 0);
    realRect.y1 = Math.max(realRect.y1, 0);
    realRect.x2 = Math.min(realRect.x2, imageRect.width);
    realRect.y2 = Math.min(realRect.y2, imageRect.height);

    const extendedRect = {
      x1: realRect.x1 - xpad,
      y1: realRect.y1 - ypad,
      x2: realRect.x2 + xpad,
      y2: realRect.y2 + ypad,
    };

    extendedRect.x1 = Math.max(extendedRect.x1, 0);
    extendedRect.y1 = Math.max(extendedRect.y1, 0);
    extendedRect.x2 = Math.min(extendedRect.x2, imageRect.width);
    extendedRect.y2 = Math.min(extendedRect.y2, imageRect.height);

    return {
      id: uuid_v4(),
      width: size * 2,
      square: (realRect.x2 - realRect.x1) * (realRect.y2 - realRect.y1),
      realRect,
      extendedRect,
    };
  }).filter((face) => {
    return face != null;
  }).sort((a, b) => {
    return b.square - a.square;
  });

  if (options.checkIntersections) {
    faces.forEach((face, index) => {
      if (face.isInvalid) {
        return;
      }

      for (let i = index + 1; i < faces.length; i++) {
        const nextFace = faces[i];
        const rect = getIntersectingRect(face.realRect, nextFace.realRect);
        const rectSquare = (rect.x2 - rect.x1) * (rect.y2 - rect.y1);
        if (rectSquare / face.square > 0.7) {
          nextFace.isInvalid = true;
        }
      }
    });
  }

  return faces.filter((face) => {
    return !face.isInvalid;
  });
}

function distance(p1, p2) {
  return Math.hypot(p1.x - p2.x, p1.y - p2.y);
}

// eslint-disable-next-line no-unused-vars
function intersectRect(r1, r2) {
 return !(r2.x1 > r1.x2 || r2.x2 < r1.x1 || r2.y1 > r1.y2 || r2.y2 < r1.y1);
}

function getIntersectingRect(r1, r2) {
  const x = Math.max(r1.x1, r2.x1);
  const y = Math.max(r1.y1, r2.y1);
  const xx = Math.min(r1.x2, r2.x2);
  const yy = Math.min(r1.y2, r2.y2);

  return {
    x1: x,
    y1: y,
    x2: xx,
    y2: yy,
  };
}
